(function () {
  // set a cookie based on all UTM tags
  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; path=/; expires=' + expires;
  }

  // get a cookie by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // check for UTM parameters in URL
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  utmParams.forEach((param) => {
    const paramValue = urlParams.get(param);
    console.log('UTM Param:', param, 'Value:', paramValue);
    if (paramValue) {
      setCookie(param, paramValue, 30); // set cookie for 30 days
    }
  });
})();
